import Swiper from 'swiper/bundle';
import flatpickr from 'flatpickr';
import { German } from 'flatpickr/dist/l10n/de.js';
import 'flatpickr/dist/flatpickr.min.css';
jQuery(document).ready(function () {
    initBrowserCheck();
    initAnchorLinkHandler();
    scrollToHashIfExists();
    initScrollSpy();
    handleMobileMenu();
    handleIpadMenu();
    initCTA()
    valueSlider();
    initializeAccordion();
    initCF7SubmitState();
    /*weekendLock();*/
    initFieldColors();
});


function initCF7SubmitState() {

    jQuery(document).on('submit', '.wpcf7-form', function () {
        jQuery(this).addClass('submitted');
    });

}


function weekendLock(){

    jQuery(document).on('change', '.wunschdatum', function () {

        const selectedDate = new Date(this.value);
        const day = selectedDate.getDay();

        if (day === 0 || day === 6) {

            alert('Bitte wählen Sie einen Termin von Montag bis Freitag.');

            this.value = '';

        }

    });

}

function initFieldColors() {
    // Alle relevanten Felder auswählen
    const $fields = jQuery('.bevorzugteTerminart, .wunschzeitraum, .wunschdatum');

    function checkValue(el) {
        const $el = jQuery(el);
        // Prüfen, ob der Wert nicht leer ist und nicht dem Label entspricht
        if ($el.val() && $el.val() !== "") {
            $el.addClass('has-value');
        } else {
            $el.removeClass('has-value');
        }
    }

    // Beim Laden der Seite prüfen
    $fields.each(function() {
        checkValue(this);
    });

    // Bei jeder Änderung prüfen
    $fields.on('change input', function() {
        checkValue(this);
    });
}


// Init BrowserCheck
function initBrowserCheck() {
    function isIE() {
        var ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

        return is_ie;
    }

    /* Create an alert to show if the browser is IE or not */
    if (isIE()) {
        jQuery('.ie-check').show();
    }
}


function initAnchorLinkHandler() {
    const anchorLinks = document.querySelectorAll(
        '.svl-main-menu a[href^="#"], .mobile-menu-overlay a[href^="#"], .ipad-menu-content a[href^="#"]'
    );

    anchorLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            const targetId = this.getAttribute('href');

            if (!targetId || !targetId.startsWith('#')) return;

            const targetEl = document.querySelector(targetId);

            if (targetEl) {
                e.preventDefault();

                const offsetTop = window.pageYOffset + targetEl.getBoundingClientRect().top;
                const scrollPosition = offsetTop - (window.innerHeight / 2) + (targetEl.offsetHeight / 2);

                window.scrollTo({
                    top: scrollPosition,
                    behavior: "smooth"
                });

                history.pushState(null, null, targetId);

            } else {
                e.preventDefault();
                window.location.href = window.location.origin + '/google-for-jobs/' + targetId;
            }
        });
    });
}


function scrollToHashIfExists() {
    const hash = window.location.hash;

    if (hash) {
        const target = document.querySelector(hash);

        if (target) {
            setTimeout(() => {
                const offsetTop = window.pageYOffset + target.getBoundingClientRect().top;
                const scrollPosition = offsetTop - (window.innerHeight / 2) + (target.offsetHeight / 2);

                window.scrollTo({
                    top: scrollPosition,
                    behavior: "smooth"
                });
            }, 300);
        }
    }
}


function initScrollSpy() {
    const sectionIds = [
        'vorteile',
        'sichtbarkeit',
        'voraussetzung',
        'infomaterial',
        'faq',
        'kontakt'
    ];

    const sections = sectionIds
        .map(id => document.getElementById(id))
        .filter(Boolean);

    const navLinks = document.querySelectorAll(".svl-main-menu a");
    let sectionPositions = [];

    navLinks.forEach(link => link.classList.remove("is-active"));

    function updatePositions() {
        sectionPositions = [];

        sections.forEach(section => {
            const id = section.getAttribute("id");
            const rect = section.getBoundingClientRect();
            const offsetTop = window.scrollY + rect.top;

            sectionPositions.push({id, offsetTop});
        });
    }

    function setActiveSection() {
        const scrollPos = window.scrollY + window.innerHeight / 2;

        if (sectionPositions.length > 0 && scrollPos < sectionPositions[0].offsetTop - 50) {
            navLinks.forEach(link => link.classList.remove("is-active"));
            return;
        }

        let currentId = null;

        for (let i = 0; i < sectionPositions.length; i++) {
            const thisSection = sectionPositions[i];
            const nextSection = sectionPositions[i + 1];

            if (!nextSection || scrollPos < nextSection.offsetTop) {
                currentId = thisSection.id;
                break;
            }
        }

        if (currentId) {
            navLinks.forEach(link => {
                const href = link.getAttribute("href");
                link.classList.toggle("is-active", href && href.includes(`#${currentId}`));
            });
        } else {
            navLinks.forEach(link => link.classList.remove("is-active"));
        }
    }

    updatePositions();
    setActiveSection();

    window.addEventListener("resize", updatePositions);
    window.addEventListener("scroll", setActiveSection);
}


function handleMobileMenu() {
    const $burger = $('#burgerToggle');
    const $menu = $('#mobileMenu');
    const $header = $('.header-front');

    $burger.on('click', function () {
        if ($(window).width() >= 768) return;

        const isActive = $menu.hasClass('active');

        if (!isActive) {
            $menu.removeClass('closing').addClass('active');
            $('body').addClass('no-scroll');
            $burger.addClass('open');

            $header.addClass('no-transition no-blur');
            setTimeout(() => $header.removeClass('no-transition'), 10);
        } else {
            $menu.removeClass('active').addClass('closing');
            $('body').removeClass('no-scroll');
            $burger.removeClass('open');

            setTimeout(() => {
                $menu.removeClass('closing');
                $header.removeClass('no-blur');
            }, 400);
        }
    });

    $menu.on('click', function (e) {
        if ($(window).width() >= 768) return;
        if (e.target === this) {
            $menu.removeClass('active').addClass('closing');
            $('body').removeClass('no-scroll');
            $burger.removeClass('open');
            setTimeout(() => {
                $menu.removeClass('closing');
                $header.removeClass('no-blur');
            }, 400);
        }
    });

    $('.mobile-menu-items a').on('click', function () {
        if ($(window).width() >= 768) return;
        $menu.removeClass('active').addClass('closing');
        $('body').removeClass('no-scroll');
        $burger.removeClass('open');
        setTimeout(() => {
            $menu.removeClass('closing');
            $header.removeClass('no-blur');
        }, 400);
    });

    $(window).on('resize', function () {
        if ($(window).width() >= 768) {
            $menu.removeClass('active closing');
            $('body').removeClass('no-scroll ipad-menu-open');
            $burger.removeClass('open');
            $header.removeClass('no-blur no-transition');
        }
    });
}


function handleIpadMenu() {
    const $burger = $('#burgerToggle');
    const $ipadMenu = $('#ipadMenuModal');

    $burger.on('click', function () {
        if ($(window).width() >= 768 && $(window).width() < 1050) {
            if ($ipadMenu.hasClass('open')) {
                $ipadMenu.removeClass('open');
                $('body').removeClass('no-scroll ipad-menu-open');
                $burger.removeClass('open');
            } else {
                $ipadMenu.addClass('open');
                $('body').addClass('no-scroll ipad-menu-open');
                $burger.addClass('open');
            }
        }
    });

    $ipadMenu.on('click', function (e) {
        if ($(e.target).is('#ipadMenuModal')) {
            $ipadMenu.removeClass('open');
            $('body').removeClass('no-scroll ipad-menu-open');
            $burger.removeClass('open');
        }
    });

    $ipadMenu.find('a[href^="#"]').on('click', function () {
        $ipadMenu.removeClass('open');
        $('body').removeClass('no-scroll ipad-menu-open');
        $burger.removeClass('open');
    });

    $(window).on('resize', function () {
        if ($(window).width() < 768 || $(window).width() >= 1050) {
            $ipadMenu.removeClass('open');
            $('body').removeClass('no-scroll ipad-menu-open');
            $burger.removeClass('open');
        }
    });
}


function initCTA() {
    jQuery('.cta-container').hide();
    let isClosed = false;
    let hasScrolled = false;

    jQuery(window).on('scroll', function () {
        if (jQuery(this).scrollTop() > 200 && !isClosed && !hasScrolled) {
            hasScrolled = true;
            jQuery('.cta-container').fadeIn();
        }
    });

    jQuery('.close-cta').on('click', function () {
        jQuery('.cta-container').fadeOut();
        isClosed = true;
        jQuery(window).off('scroll');
    });
}


function valueSlider() {
    var swiper = new Swiper('.value-swiper', {
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 1,
        loop: true,
        speed: 600,
        spaceBetween: 10,
        preventClicks: true,
        effect: 'slide',
        /*autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },*/
        pagination: { el: '.swiper-pagination', clickable: true },
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        breakpoints: {
            768: {
                slidesPerView: 3,
                effect: 'coverflow',
                coverflowEffect: {
                    rotate: 0, stretch: 50, depth: 150, modifier: 1, slideShadows: false
                }
            }
        }
    });

    jQuery(function ($) {
        $('.value-swiper').on('click', '.swiper-slide-active img', function () {
            const src = $(this).attr('src');
            $('#modal-image').attr('src', src);
            $('#image-modal').addClass('is-open');
            $('body').addClass('no-scroll');
        });

        $('.value-swiper').on('click', '.swiper-slide img', function (e) {
            if (!$(this).closest('.swiper-slide').hasClass('swiper-slide-active')) {
                e.stopImmediatePropagation();
                e.preventDefault();
            }
        });

        $('.modal-close, #image-modal').on('click', function (e) {
            if (!$(e.target).is('#modal-image')) {
                $('#image-modal').removeClass('is-open');
                $('body').removeClass('no-scroll');
            }
        });
    });
}


document.addEventListener("DOMContentLoaded", () => {
    const row = document.querySelector("form.form-fields .form-row");
    if (!row) return;

    function ensureGroup(el, mod = "") {
        if (!el) return null;
        if (el.parentElement?.classList.contains("field-group")) return el.parentElement;

        const wrap = document.createElement("div");
        wrap.className = "field-group" + (mod ? " " + mod : "");
        el.replaceWith(wrap);
        wrap.appendChild(el);
        return wrap;
    }

    const nameInput  = row.querySelector('input[name="global.firstname"]');
    const mailInput  = row.querySelector('input[name="email"]');
    const checkboxLb = row.querySelector("label.checkbox-container");
    const btn        = row.querySelector(".button-primary");

    const gName = ensureGroup(nameInput,  "field-group--name");
    const gMail = ensureGroup(mailInput,  "field-group--mail");
    const gCbx  = ensureGroup(checkboxLb, "field-group--full");
    const gBtn  = ensureGroup(btn,        "field-group--button");

    [gName, gMail, gCbx].forEach(g => {
        if (g && !g.querySelector(".error-message")) {
            const slot = document.createElement("div");
            slot.className = "error-message";
            g.appendChild(slot);
        }
    });

    function setError(field, message, isCheckbox = false) {
        const target = isCheckbox ? field.closest("label.checkbox-container") : field;
        const group  = target?.closest(".field-group");
        const slot   = group?.querySelector(".error-message");
        if (slot) slot.textContent = message || "";
        field.classList.toggle("field-error", !!message);
    }

    function validateForm() {
        const checkbox = row.querySelector('input[type="checkbox"][name="tags[]"]');
        let ok = true;

        if (!nameInput.value.trim()) { setError(nameInput, "Bitte gib deinen Namen ein."); ok = false; }
        else                         { setError(nameInput, ""); }

        const v = mailInput.value.trim();
        const pat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!v)              { setError(mailInput, "Bitte gib deine E-Mail-Adresse ein."); ok = false; }
        else if (!pat.test(v)) { setError(mailInput, "Bitte gib eine gültige E-Mail-Adresse ein."); ok = false; }
        else                 { setError(mailInput, ""); }

        if (!checkbox.checked) { setError(checkbox, "Bitte akzeptiere die Bedingungen.", true); ok = false; }
        else                   { setError(checkbox, "", true); }

        return ok;
    }

    const formEl = document.querySelector("form.form-fields");
    formEl.setAttribute("novalidate", "true");
    formEl.querySelectorAll("[required]").forEach(el => el.removeAttribute("required"));
    formEl.addEventListener("submit", e => { if (!validateForm()) e.preventDefault(); });

    nameInput.addEventListener("input", () =>
        setError(nameInput, nameInput.value.trim() ? "" : "Bitte gib deinen Namen ein."));
    mailInput.addEventListener("input", () => {
        const v = mailInput.value.trim();
        const ok = v && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
        setError(mailInput, ok ? "" : (v ? "Bitte gib eine gültige E-Mail-Adresse ein." : "Bitte gib deine E-Mail-Adresse ein."));
    });
    row.querySelector('input[type="checkbox"][name="tags[]"]').addEventListener("change", (e) =>
        setError(e.target, e.target.checked ? "" : "Bitte akzeptiere die Bedingungen.", true));
});


function initializeAccordion() {
    $('.accordion-item').on('click', function (e) {
        if ($(e.target).closest('a, button').length > 0) return;

        const $clickedItem = $(this);

        if ($clickedItem.hasClass('open')) {
            $clickedItem.removeClass('open');
        } else {
            $('.accordion-item').not($clickedItem).removeClass('open');
            $clickedItem.addClass('open');
        }
    });
}




document.addEventListener("DOMContentLoaded", function () {
    const forms = document.querySelectorAll(".wpcf7 form");

    function toggleFieldState(field) {
        if (!field) return;

        const tag = field.tagName.toLowerCase();

        if (tag === "select") {
            if (field.selectedIndex > 0 && field.value.trim() !== "") {
                field.classList.add("has-value");
            } else {
                field.classList.remove("has-value");
            }
            return;
        }

        if (field.value && field.value.trim() !== "") {
            field.classList.add("has-value");
        } else {
            field.classList.remove("has-value");
        }
    }

    function resetFormVisualState(form) {
        if (!form) return;

        const fields = form.querySelectorAll("input, textarea, select");
        fields.forEach(function (field) {
            field.classList.remove("has-value");
        });

        const selects = form.querySelectorAll("select");
        selects.forEach(function (select) {
            select.selectedIndex = 0;
            select.classList.remove("has-value");
        });

        const dateFields = form.querySelectorAll(".js-date-picker");
        dateFields.forEach(function (field) {
            field.value = "";
            field.classList.remove("has-value");
        });
    }

    const dateFields = document.querySelectorAll(".js-date-picker");

    dateFields.forEach(function (field) {
        flatpickr(field, {
            locale: German,
            dateFormat: "d.m.Y",
            minDate: "today",
            allowInput: false,
            disableMobile: true,
            disable: [
                function(date) {
                    return date.getDay() === 0 || date.getDay() === 6;
                }
            ],
            onReady: function(selectedDates, dateStr, instance) {
                toggleFieldState(instance.input);
            },
            onChange: function(selectedDates, dateStr, instance) {
                toggleFieldState(instance.input);
            }
        });
    });

    document.querySelectorAll("input, textarea, select").forEach(function (field) {
        const eventName = field.tagName.toLowerCase() === "select" ? "change" : "input";

        field.addEventListener(eventName, function () {
            toggleFieldState(field);
        });

        toggleFieldState(field);
    });

    document.addEventListener("wpcf7mailsent", function (event) {
        resetFormVisualState(event.target);
    });

    document.addEventListener("wpcf7submit", function (event) {
        window.setTimeout(function () {
            resetFormVisualState(event.target);
        }, 100);
    });
});